<script setup lang="ts">
import Uppy from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

const props = defineProps({
  placeholder: {
    type: String,
    default: "",
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  isValid: {
    type: Boolean,
    default: true,
  },
  min: {
    type: Number,
    default: 1,
  },
  max: {
    type: Number,
    default: 1,
  },
  modelValue: {
    type: [Object, Array],
    default: () => [],
  },
  height: {
    type: String,
    default: "small",
  },
});

const emit = defineEmits(["update:modelValue", "clear"]);
const open = ref(false);
const uppy = ref(null);
const loaded = ref(false);
const mounted = ref(false);
const isLeave = ref(false);
const { multiple, modelValue } = toRefs(props);

// const _height = computed(() => {
//   switch (props.height) {
//     case "small":
//       return "h-36";
//     case "middle":
//       return "h-76";
//     case "large":
//       return "h-101";
//   }
// });

function* serializeSubPart(key, value) {
  if (typeof value !== "object") {
    yield [key, value];
    return;
  }
  if (Array.isArray(value)) {
    for (const val of value) {
      yield* serializeSubPart(`${key}[]`, val);
    }
    return;
  }
  for (const [subkey, val] of Object.entries(value)) {
    yield* serializeSubPart(key ? `${key}[${subkey}]` : subkey, val);
  }
}
function serialize(data) {
  // If you want to avoid preflight requests, use URL-encoded syntax:
  return new URLSearchParams(serializeSubPart(null, data));
  // If you don't care about additional preflight requests, you can also use:
  // return JSON.stringify(data)
  // You'd also have to add `Content-Type` header with value `application/json`.
}

function showModal() {
    open.value = true;
}

function closeModal() {
  open.value = false;
}

function onComplete(result) {
  loaded.value = false;
  result.successful.forEach((element) => {
    emit("update:modelValue", element);
    loaded.value = true;
  });
}

function clearValue() {
  emit("update:modelValue", null);
  emit("clear");
}

onMounted(() => {
  try {
    const MiB = 0x10_00_00;

    const options = {
      minNumberOfFiles: 1,
      maxNumberOfFiles: multiple.value ? 100500 : 1,
    };
    uppy.value = new Uppy().use(AwsS3, {
      limit: 5,
      companionUrl: "https://companion.asar.studio",
    });
  } catch (error) {
    console.error(error);
  }
  uppy.value.on("complete", onComplete);
  mounted.value = true;
});

onBeforeUnmount(() => {
  uppy.value.close();
});
</script>
<template>
  <div id="DashboardContainer" v-if="mounted">
    <div class="UppyModalOpenerBtn">
      <div
        class="w-full relative h-[48px]"
        @mouseover="isLeave = true"
        @mouseleave="isLeave = false"
      >
        <VueUppyButton @click="showModal" @clear="clearValue" :is-valid="isValid">{{
          !!modelValue ? `${modelValue.name}` : placeholder
        }}</VueUppyButton>
      </div>
    </div>
    <VueUppyDashboard
      v-if="uppy"
      :uppy="uppy"
      :open="open"
      :data="{
        onRequestCloseModal: closeModal,
        height: 550,
      }"
    ></VueUppyDashboard>
  </div>
</template>
<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease-in;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
